import Vue from 'vue';
import VueCroppie from 'vue-croppie';

Vue.use(VueCroppie);
